export interface LatestMetricSample {
  t: Date;
  value: number;
}

export interface LatestMetricRow {
  value: number;
  latestObservedAt: number;
  summaryValue: number;
}

/** Select the newest raw sample; chart transformations must not affect KPI semantics. */
export const latestRawMetricSample = (samples: readonly LatestMetricSample[]): LatestMetricSample | null => {
  const valid = samples.filter((sample) => Number.isFinite(sample.value) && Number.isFinite(sample.t.getTime()));
  return valid.reduce<LatestMetricSample | null>(
    (latest, sample) => (!latest || sample.t.getTime() > latest.t.getTime() ? sample : latest),
    null
  );
};

export const compareLatestMetricRows = (left: LatestMetricRow, right: LatestMetricRow): number =>
  right.value - left.value || right.latestObservedAt - left.latestObservedAt || right.summaryValue - left.summaryValue;
